import { render } from "./TypeOwner.vue?vue&type=template&id=cdb36e28&scoped=true&ts=true"
import script from "./TypeOwner.vue?vue&type=script&lang=ts"
export * from "./TypeOwner.vue?vue&type=script&lang=ts"

import "./TypeOwner.vue?vue&type=style&index=0&id=cdb36e28&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdb36e28"]])

export default __exports__